const Index = () => import(/* webpackChunkName: "proj" */ './Index');
const Personal = () => import(/* webpackChunkName: "proj" */ './Personal');
const Create = () => import(/* webpackChunkName: "proj" */ './Create');
const Manage = () => import(/* webpackChunkName: "proj" */ './Manage');
const ProjIncoIndex = () => import(/* webpackChunkName: "proj" */ './inco/Index');
const ProjIncoPersonal = () => import(/* webpackChunkName: "proj" */ './inco/Personal');

import FundPart from '@/components/proj/fund/part/router'
import Type from '@/components/proj/type/router'
import Rept from '@/components/proj/rept/router'
import ConclMulti from '@/components/proj/concl_multi/router'

import BudgetDict from '@/components/proj/budget_dict/router'
import BudgetTplt from '@/components/proj/budget_tplt/router'
import Review from "@/components/proj/review/router";
// import BudgetItem from '@/components/proj/budget_item/router'
import IncoClaim from '@/components/proj/incoclaim/router'
import IccoClaimSplit from '@/components/proj/inco_claim_split/router'

export default {
    routes: [
        {
            path: '/proj/project',
            name: 'porj_project',
            component: Index
        },
        {
            path: '/proj/personal',
            name: 'porj_personal',
            component: Personal
        },
        {
            path: '/proj/create',
            name: 'porj_create',
            component: Create
        },
        {
            path: '/proj/manage/:dbid',
            name: 'porj_manage',
            component: Manage
        },
        {
            path: '/proj/inco/index',
            name: 'porj_inco/index',
            component: ProjIncoIndex
        },{
            path: '/proj/inco/personal',
            name: 'porj_inco/personal',
            component: ProjIncoPersonal
        },
        ...FundPart.routes,
        ...Type.routes,
        ...Rept.routes,
        ...ConclMulti.routes,
        ...BudgetDict.routes,
        ...BudgetTplt.routes,
        ...IncoClaim.routes,
        ...IccoClaimSplit.routes,
        ...Review.routes

        // ...BudgetItem.routes
    ]
}
